import { LoadingService } from './../../../services/loading.service';
import { SearchService } from './../../../services/search.service';
import { Component, OnInit, Inject, EventEmitter, Output, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { AuthService } from './../../../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { BookingService } from 'src/app/services/booking.service';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Router } from '@angular/router';
import { faChevronCircleLeft, faChevronCircleRight, faBriefcase, faGasPump, faUser, faMapMarkerAlt, faCar, faKey, faTags, faDollarSign, faRoad, faBatteryHalf, faBan } from '@fortawesome/free-solid-svg-icons';
import { MatIconRegistry } from "@angular/material/icon";
import { VehicleSearchTypeEnum } from 'src/app/models/enums/VehicleSearchTypeEnum';



import { Branch } from './../../../models/Branch';
import { ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { faCalendarAlt, faClock } from '@fortawesome/free-solid-svg-icons';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { Address } from 'ngx-google-places-autocomplete/objects/address';
import { UiSwitchModule } from 'ngx-ui-switch';
import { ThemePalette } from '@angular/material/core';
import { VehicleReservationSearchParm } from './../../../models/VehicleReservationSearchParm';
import { DateFormatPipe } from './../../../common/pipes/DateFormatPipe';
//import { DatePipe } from '@angular/common';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { IconService } from './../../../services/icon.service';
import { DropUpLocaionModel } from 'src/app/models/DropUpLocaionModel';
import { VehicleReservationCaseResult } from 'src/app/models/Booking/VehicleReservationCaseResult';
import { BehaviorSubject } from 'rxjs';
import { ModeType } from 'src/app/models/enums/BookingEnums';
//import { DOCUMENT } from '@angular/common';


import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';


declare var $: any;
declare const svgToUrlImage: any;
declare const myTest: any;

@Component({
  selector: 'extend-rental-time-modal',
  templateUrl: './extend-rental-time-modal.component.html',
  styleUrls: ['./extend-rental-time-modal.component.css'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
})
export class ExtendRentalTimeModalComponent implements OnInit, AfterViewInit, OnDestroy {

  currentLocation = { lat: 0, lng: 0 };
  faChevronDown = faChevronDown;
  searchForm: FormGroup;
  submitted = false;
  faMapMarkerAlt = faMapMarkerAlt;
  faCalendarAlt = faCalendarAlt;
  easyRent = false;
  address: Address = new Address();
  options = {
    types: []
    //componentRestrictions: {}
  };

  minPickUpDate: any = new Date();
  minDropOffDate: any;
  minTime: any;

  //Slide toggle
  color: ThemePalette = 'accent';
  checked = false;
  disabled = false;
  manualUpdate: boolean;
  faClock = faClock;

  vehicle;
  currency;
  duration;
  extendPeriod;
  totalCharges;

  faTimesCircle = faTimesCircle;
  faBriefcase = faBriefcase;
  faGasPump = faGasPump;
  faUser = faUser;
  faCar = faCar;
  faKey = faKey;
  faTags = faTags;
  faDollarSign = faDollarSign;
  faRoad = faRoad;
  faBatteryHalf = faBatteryHalf;
  faBan = faBan;
  faChevronCircleLeft = faChevronCircleLeft;
  faChevronCircleRight = faChevronCircleRight;
  success = false;
  notAvailable = false;

  parameters: Array<string> = ["T"];

  selectedLang: any;
  locations;
  caseId;
  result;
  endTime;
  endDate;
  dropUpLocations: DropUpLocaionModel[];
  needPayment: boolean;
  requiredPayment: any;
  vehicleReservationCaseResult: VehicleReservationCaseResult;
  newDurationData;
  unavailableAditionalServiceData;



  @Output() onCancel = new EventEmitter();
  notAvailableReason: NotAvailableReasonEnum;
  objPayment: any;
  isDropOffSameAsPickUp: boolean;
  isFirstTime: boolean = true; currentTotalCharge: any;


  extendpayment: boolean = true;

  constructor(
    private loadingService: LoadingService,
    private formBuilder: FormBuilder,
    protected cdr: ChangeDetectorRef,
    private searchService: SearchService,
    private domSanitizer: DomSanitizer,
    private bookingService: BookingService,
    //private dialogRef: MatDialogRef<ExtendRentalTimeModalComponent>,
    //@Inject(MAT_DIALOG_DATA) data,
    private authService: AuthService,
    public translateService: TranslateService,
    private _dateFormatPipe: DateFormatPipe,
    private router: Router,
    private iconService: IconService,
    private matIconRegistry: MatIconRegistry,
    private _adapter: DateAdapter<any>) {
    //this.vehicle = searchService.getVehicle();
    this.currency = searchService.getCurrency();


    // this.matIconRegistry.addSvgIcon(
    //   "car-gear",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carGearIcon)
    // );
    // this.matIconRegistry.addSvgIcon(
    //   "car-door",
    //   this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.carDoorIcon)
    // );
    this.matIconRegistry.addSvgIcon(
      "timeIcon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.timeIcon)
    );
    this.matIconRegistry.addSvgIcon(
      "supplierMapIcon",
      this.domSanitizer.bypassSecurityTrustResourceUrl(iconService.supplierMapIcon)
    );

  }
  ngOnDestroy(): void {
    this.newDurationData.next(null);
    this.unavailableAditionalServiceData.next(null);
  }

  ngOnInit() {
    this.newDurationData = new BehaviorSubject(null);
    this.unavailableAditionalServiceData = new BehaviorSubject(null);
    let scopeMinTime;
    let minTime;
    this.searchService.reservationSettingModel.subscribe(res => {
      let gracePeriod = 0;
      if (res != null) {
        gracePeriod = res.bookingGracePeriodSettings.bookingGracePeriodInHours;
      }
      scopeMinTime = this.searchService.getFirstValidSartTime(new Date(), gracePeriod); //For the Jquery,



    })

    this.bookingService.vehicleReservationCaseResult.subscribe(res => {
      this.vehicleReservationCaseResult = res;

      let endTime = res.endTimeString.replace(" ", "");
      minTime = endTime;
      this.minTime = endTime;
      this.minDropOffDate = new Date(res.endDate);
      this.searchForm = this.formBuilder.group({
        location: [{ value:res.dropOffLocationID, disabled: true }, Validators.required],
        endDate: [new Date(res.endDate), Validators.required],
        endTime: [endTime, Validators.required],
      });

      // this.bookingService.getOneWayRentalLocaions(res.agencyID, res.dropOffLocationID, ModeType.Edit, null, res.classID, res.makeID, res.modelID, res.year,res.vehicleID,true)
      //     .subscribe(dropUpLocations => {
      //   //this.dropUpLocations = dropUpLocations;
      //   //this.searchForm.controls['location'].setValue(res.dropOffLocationID);

      // });
      this.searchService.getDropUpLocationsByAgencyID(res.agencyID, '', false, res.classID, res.makeID, res.modelID, res.year, res.vehicleID).subscribe(dropUpLocations => {
        this.dropUpLocations = dropUpLocations.filter(a =>a.returnAgencyID==res.dropOffLocationID);
        this.searchForm.controls['location'].setValue(res.dropOffLocationID);
      })
    })



    $(document).ready(function () {
      //Initilize the Time Picker for pick up and drop off
      $('#pickUpTime').timepicker({ 'step': 15, 'maxTime': '11:45pm', 'lang': { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM', decimal: '.', mins: 'mins', hr: 'hr', hrs: 'hrs' } });
      //There is no min time in drop off , because its a day after
      $('#endTime').timepicker({ 'step': 15, 'minTime': minTime, 'maxTime': '11:45pm', 'lang': { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM', decimal: '.', mins: 'mins', hr: 'hr', hrs: 'hrs' } });

    });

    this.bookingService.vehicle.subscribe(res => {
      this.vehicle = res;
    });

    this.caseId = this.bookingService.CaseID;
  }
  get NotAvailableReasonEnum() {
    return NotAvailableReasonEnum;
  }
  ngAfterViewInit() {

    //Attach onChange Event
    $('#pickUpTime').on('changeTime', (e, dateText) => {

      this.searchForm.controls.PickUpTime.setValue($(e.target).val());
      //this.searchForm.controls.PickUpTime.setValue(dateText);
    });
    $('#endTime').on('changeTime', (e, dateText) => {

      this.searchForm.controls.endTime.setValue($(e.target).val());
      //this.searchForm.controls.PickUpTime.setValue(dateText);
    });


    // This is For changing language for the calendar
    this.selectedLang = JSON.parse(localStorage.getItem("lang"));
    switch (this.selectedLang.isoCode2) {
      case "en":
        this._adapter.setLocale('en-US');
        break;
      case "ar":
        this._adapter.setLocale('ar-ly');
        break;
      default:
        this._adapter.setLocale('en-US');
        break;
    }

  }


  onExtend() {
    //reset the variables.
    this.notAvailable = false;
    this.success = false;

    this.endTime = this.searchForm.controls["endTime"].value as string;
    //Format Jquery Time Picker to match API(C#) EndTimeString , and then compare them
    let formatedNewEndTime = '';
    if (this.endTime != null) {
      formatedNewEndTime = this.endTime.toLocaleLowerCase().replace(" ", "");
      let firstSection = formatedNewEndTime.split(":")[0];
      if (firstSection.length == 1) {
        formatedNewEndTime = "0" + formatedNewEndTime;
      }

    }

    this.endDate = this._dateFormatPipe.transform(this.searchForm.value['endDate']);
    let formatedOldEndTime = this.vehicleReservationCaseResult.endTimeString.toLocaleLowerCase().replace(" ", "");
    if (this.vehicleReservationCaseResult.endDateString == this.endDate && formatedOldEndTime == formatedNewEndTime) {
      this.isDropOffSameAsPickUp = true;
      return;
    }
    else {
      this.isDropOffSameAsPickUp = false;
    }
    let droppOffLocationID = this.searchForm.value['location'];
    let droppOffLocation = this.dropUpLocations.filter(a => a.returnAgencyID == droppOffLocationID)[0];
    //let droppOffLocation = this.searchForm.value['location'] as DropUpLocaionModel;
    //this.endDate="28/09/2020";
    setTimeout(() => {
      this.loadingService.updateLoadingState(true);
    });
    this.bookingService.checkAvailabilityVehicleForExtensionPeriod(this.caseId, this.endDate, this.endTime, this.vehicleReservationCaseResult.dropOffLocationID, this.vehicleReservationCaseResult.dropOffLocationTypeID).subscribe(res => {
      this.result = res;



      if (this.result.unavailableAdditional) {
        this.notAvailable = true;
        this.notAvailableReason = NotAvailableReasonEnum.UnavailableAdditional;
        this.unavailableAditionalServiceData.next(this.result.lstUnavailableAdditionalServiceReservationCaseModel);
      }
      else if (this.result.returnLocationIsNotAvailable) {
        this.notAvailable = true;
        this.notAvailableReason = NotAvailableReasonEnum.ReturnLocationIsNotAvailable
      }
      else if (this.result.isExpiredIdentity) {
        this.notAvailable = true;
        this.notAvailableReason = NotAvailableReasonEnum.ExpiredIdntity
      }
      else if (this.result.isVehicleNotAvailble) {
        this.notAvailable = true;
        this.notAvailableReason = NotAvailableReasonEnum.VehicleNotAvailble
      }
      else if (this.result.isAvailable) {
        this.success = true;



        this.newDurationData.next(res);
      } else {
        this.notAvailable = true;
        this.notAvailableReason = NotAvailableReasonEnum.NotAvailablePeriod;

      }
      this.loadingService.updateLoadingState(false);
    })
  }

  confirmExtend() {

    this.endTime = this.searchForm.controls["endTime"].value;
    this.endDate = this._dateFormatPipe.transform(this.searchForm.value['endDate']);
    let droppOffLocationID = this.searchForm.value['location'];
    let droppOffLocation = this.dropUpLocations.filter(a => a.returnAgencyID == droppOffLocationID)[0];

    setTimeout(() => {
      this.loadingService.updateLoadingState(true);
    });
    this.bookingService.reservationExtendContract(this.caseId, this.endDate, this.endTime, this.vehicleReservationCaseResult.dropOffLocationID,  this.vehicleReservationCaseResult.dropOffLocationTypeID).subscribe(res => {
      // this._document.defaultView.location.reload();

      //this.result = res;

      let result: any = res;
      if (res != null) {
        if (result.needPayment) {
          this.needPayment = true;
          this.requiredPayment = res["requiredPayment"];
          this.objPayment = res["objPayment"];
        }
        else if (result.unavailableAdditional) {
          this.notAvailable = true;
          this.notAvailableReason = NotAvailableReasonEnum.UnavailableAdditional;
          this.unavailableAditionalServiceData.next(this.result.lstUnavailableAdditionalServiceReservationCaseModel);
        }
        else if (result.returnLocationIsNotAvailable) {
          this.notAvailable = true;
          this.notAvailableReason = NotAvailableReasonEnum.ReturnLocationIsNotAvailable
        }
        else if (result.isAvailable) {
          this.success = true;

          this.newDurationData.next(res);
        }
        else {
          //this.dialogRef.close();
          this.bookingService.updateViewBookingState();
          this.loadingService.updateLoadingState(false);
          this.onCancel.emit(true);
          this.ngOnDestroy();
        }
      }
      else {
        //this.dialogRef.close();
        this.bookingService.updateViewBookingState();
        this.loadingService.updateLoadingState(false);
      }


    })
  }

  cancelChange() {
    this.onCancel.emit(true);
    this.ngOnDestroy();
    //this.dialogRef.close();
    //window.location.reload();
    //this.router.navigate(["view-booking;CaseID=" + this.caseId]);
    //this.router.navigate(['/view-booking',{CaseID:myBookings.caseID}]);
  }


  public handleAddressChange(address: Address) {
    // Do some stuff

    this.currentLocation = {
      lat: address.geometry.location.lat(),
      lng: address.geometry.location.lng(),
    };
    this.address = address;




  }

  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {


    if (new Date(event.value).getDate() == this.minDropOffDate.getDate()) {

      this.searchForm.controls.endTime.setValue(this.minTime);
      $('#endTime').timepicker('option', 'minTime', this.minTime);
      //this.searchForm.controls.PickUpTime.setValue(this.minTime);
    }
    else {
      $('#endTime').timepicker('option', 'minTime', '12:00am');
    }


  }
  close(): void {
    //this.dialogRef.close();

    this.onCancel.emit(true);
    this.ngOnDestroy();
  }

  changeViewType() {
    this.needPayment = false;
  }

  cancelClicked() {
    this.onCancel.emit(true);
    this.ngOnDestroy();
  }

  onTotalCalculated(val) {
    if (this.isFirstTime) {
      this.currentTotalCharge = val;
      this.isFirstTime = false;
    }
    else {
      this.totalCharges = val;
    }

  }


}

export enum NotAvailableReasonEnum {
  ReturnLocationIsNotAvailable,
  UnavailableAdditional,
  NotAvailablePeriod,
  ExpiredIdntity,
  VehicleNotAvailble
}
